import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { DOCUMENT_ACTION } from "../../redux/action";
import { Toaster } from "../../utils/common";
import {
  openDocumentInNewTab,
  openDocumentPreviewTab,
} from "../../utils/openDocumentInNewTab";
import "./filedCopiesDocuments.scss";

async function openFiledCopy(doc) {
  const previewTab = openDocumentPreviewTab();
  try {
    const response = await DOCUMENT_ACTION.downloadViewFile({
      document_name: doc.document_name,
      document_type: doc.document_type,
      client_document_id: doc.client_document_id,
      type: "Preview",
    });
    await openDocumentInNewTab(
      response?.raw,
      doc.document_type,
      doc.document_name,
      previewTab,
    );
  } catch (error) {
    if (previewTab && !previewTab.closed) previewTab.close();
    Toaster.error("Could not open the filed copy");
  }
}

export default function FiledCopiesDocuments({ documents }) {
  const docs = (Array.isArray(documents) ? documents : []).filter(
    (doc) => doc?.client_document_id,
  );
  if (!docs.length) return "—";

  return (
    <div className="filed-copies-cell">
      {docs.map((doc, index) => (
        <Tooltip
          key={doc.client_document_id}
          title={doc.document_name || "Document"}
        >
          <button
            type="button"
            className="filed-copies-cell__link"
            onClick={(event) => {
              event.stopPropagation();
              openFiledCopy(doc);
            }}
          >
            {index + 1}
          </button>
        </Tooltip>
      ))}
    </div>
  );
}
